import { Auth } from "../utils/auth";
import { HealthCheckApi } from "./HealthCheckApi";
import axios from "./AxiosConfig";
import Router from "../router";


export class RiskControlApi {
    healthCheck = null;
    token = null;

    constructor() {
        let auth = new Auth();
        this.token = auth.getToken();
        this.healthCheck = new HealthCheckApi();
    }

    async list(includeInactive) {
        return await axios.get(`${Router.apiBaseUrl}${Router.apiRiskControl}/RiskAssessments`, {
            params: { includeInactive }
        })
        .then(async response => {
            return await this.healthCheck.checkApi(response)
        }).catch(async error => {
            return await this.healthCheck.checkApi(error)
        })
    }

    async create(data) {
        return await axios.post(Router.apiBaseUrl + Router.apiRiskControl, data)
        .then(async response => {
            return await this.healthCheck.checkApi(response)
        }).catch(async error => {
            return await this.healthCheck.checkApi(error)
        });
    }

    async update(id, data) {
        return await axios.put(Router.apiBaseUrl + Router.apiRiskControl + `/EditRiskAssessment/${id}`, data)
        .then(async response => {
            return await this.healthCheck.checkApi(response)
        }).catch(async error => {
            return await this.healthCheck.checkApi(error)
        })
    }

    async toggleState(id) {
        return await axios.put(Router.apiBaseUrl + Router.apiRiskControl + `/ToggleStateRiskAssessment/${id}`, {})
        .then(async response => {
            return await this.healthCheck.checkApi(response)
        }).catch(async error => {
            return await this.healthCheck.checkApi(error)
        })
    }
}